export const pathImgFromIndex = "/assets/img/";
export const pathAPI = "https://friendly-classroom-be.onrender.com/api/";
